import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import {CookiesProvider, useCookies} from 'react-cookie'
import World3D from './Components/World3D'
import Auth from './Components/Auth'
import Authorize from './Components/Authorize'
import { createTheme, MantineProvider } from '@mantine/core';
import './App.css';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';



//const center = [148.9819, -35.081]


const theme = createTheme({
  /** Your theme override here */
});


const Play = (props) =>{
  const [cookies] = useCookies(['user']);
  if(!cookies.user){ 
    
    window.history.pushState({}, null, "/auth");
    return <Auth />
  }
  else{ 
    return (<CookiesProvider>
        
        
        <World3D cookies={cookies}/>
      
    </CookiesProvider>)
  }
}



function App() {
  //const a = process.env.REACT_APP_BASE_URL||'/'
 
  return (
    <div className="App">
      <MantineProvider theme={theme}>
        <CookiesProvider>
          <Router>
            <div>
              <Routes>
                <Route path="/" element={<Play/>} />
                <Route path="/authorize" element={<Authorize/>} />
                <Route path="/play" element={<Play/>} />
                <Route path="/auth" element={<Auth />} />
              </Routes>
            </div>
          </Router>
        </CookiesProvider> 
      </MantineProvider>
    </div>
  );
}

export default App;
